import { Stack } from "@mui/material";
import { ReuseEllipsisTooltip } from "../ReuseEllipsisTooltip";
import { ReactNode } from "react";
import { ClientMenu } from "./ClientMenu";
import { NotesIcon } from "../../images";
import { Client } from "../../../types/apiTypes";
import { TableColumnType } from "../../../types/genereal";

const TextCell = ({ text }: { text: string }) => (
  <ReuseEllipsisTooltip
    tooltip={text}
    children={text}
    style={{
      fontSize: "14px",
      lineHeight: "22px",
      fontWeight: 400,
      color: "#232323",
    }}
  />
);

const NameCell = ({ fullName, email }: { fullName: string; email: string }) => (
  <Stack gap={"2px"}>
    <ReuseEllipsisTooltip
      tooltip={fullName}
      children={fullName}
      style={{
        fontSize: "14px",
        lineHeight: "22px",
        fontWeight: 400,
        color: "#232323",
      }}
    />
    <ReuseEllipsisTooltip
      tooltip={email}
      children={email}
      style={{
        fontSize: "14px",
        lineHeight: "22px",
        fontWeight: 400,
        color: "#797979",
      }}
    />
  </Stack>
);

const NotesCell = ({ text }: { text: string }) => (
  <ReuseEllipsisTooltip
    tooltip={text.length > 260 ? `${text.slice(0, 260)}...` : text}
    children={<NotesIcon />}
    onlyEllipsis={false}
    maxWidth={"200px"}
  />
);

type MapperFn = (row: ClientRow, key: keyof Client) => ReactNode;
type RowClient =
  | "index"
  | "name"
  | "job_title"
  | "company_name"
  | "company_domain"
  | "notes"
  | "added"
  | "menu";

type ClientRow = Client & { index: string; isNoClient: string };

const mapper: Record<string, MapperFn> = {
  index: (row: ClientRow, key: keyof ClientRow) => <TextCell text={row[key]} />,
  name: ({ email, first_name, last_name }: ClientRow) =>
    !email && !last_name && !first_name ? (
      "--"
    ) : (
      <NameCell fullName={`${first_name} ${last_name}`} email={email} />
    ),
  job_title: (row: ClientRow, key: keyof ClientRow) => (
    <TextCell text={row[key]} />
  ),
  company_name: (row: ClientRow, key: keyof ClientRow) => (
    <TextCell text={row[key]} />
  ),
  company_domain: (row: ClientRow, key: keyof ClientRow) => (
    <TextCell text={row[key]} />
  ),
  notes: (row: ClientRow, key: keyof ClientRow) =>
    row[key] && <NotesCell text={row[key]} />,
  added: (row: ClientRow, key: keyof ClientRow) => <TextCell text={row[key]} />,
  menu: (row: ClientRow) => (
    <ClientMenu client={row} isNoClient={!row.isNoClient} />
  ),
};

type Props = {
  columns: TableColumnType[];
  row: ClientRow;
};

export const ClientListRow = ({ columns, row }: Props) => {
  return (
    <Stack
      sx={{
        flexDirection: "row",
        width: "100%",
      }}
    >
      {columns.map(({ key, minWidth, maxWidth, bgColor, textAlign }) => (
        <Stack
          key={key}
          sx={{
            minWidth,
            maxWidth,
            borderBottom: bgColor ? "none" : "1px solid #DEDEDE",
            backgroundColor: bgColor,
            p: "16px 0 16px 16px",
            width: "100%",
            textAlign: textAlign,
            justifyContent: "center",
          }}
        >
          {/*@ts-ignore*/}
          {mapper[key as RowClient](row, key as RowClient)}
        </Stack>
      ))}
    </Stack>
  );
};
